import React, { useEffect, useMemo, useState } from "react";
import { classNames } from "../../helpers/classNames";

const Badge = ({ type, label = "Label", className }) => {
  const [statusColor, setStatusColor] = useState();
  const status = useMemo(
    () => ({
      success: "bg-green-100 text-green-600/80 border border-green-200/50",
      danger: "bg-rose-100 text-rose-600/80 border border-rose-200/50",
      warning: "bg-amber-100 text-amber-600/80 border border-amber-200/50",
      info: "bg-sky-100 text-sky-600/80 border border-skysky-200/50",
      default:"bg-gray-100 text-gray-600/80 border border-gray-200/50",
      "": "",
    }),
    []
  );

  useEffect(() => {
    if (type) {
      setStatusColor(status[type]);
    }
  }, [type]);

  return (
    <div
      className={classNames(
        "whitespace-nowrap truncate capitalize text-center py-1 px-2 rounded text-xs",
        statusColor ? statusColor : "",
        className
      )}
    >
      {label}
    </div>
  );
};

export default Badge;
